import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const SKRATKY: Array<[string, string]> = [
  ["Ctrl + Enter / Insert", "Pridať dielec do vybranej zostavy (pri výbere zostáv do každej)"],
  ["Ctrl + Shift + Z", "Nová zostava"],
  ["Ctrl + D", "Duplikovať vybranú zostavu / vybrané zostavy"],
  ["Delete", "Zmazať vybraný dielec / zostavu / vybrané zostavy"],
  ["↑ / ↓", "Posun výberu dielca v tabuľke"],
  ["Alt + ↑ / ↓", "Posunúť vybraný riadok v zostave, na vybranej zostave celú zostavu (aj ťahaním za ⋮⋮)"],
  ["Enter / F2 (na bunke)", "Upraviť bunku"],
  ["Tab (v bunke)", "Uložiť a ďalšia bunka"],
  ["Escape (v bunke)", "Zrušiť úpravu"],
  ["Ctrl + klik", "Pridať / odobrať dielec alebo zostavu (na páse) z výberu"],
  ["Shift + klik", "Označiť rozsah dielcov alebo zostáv"],
  ["Ctrl + C / Ctrl + X", "Kopírovať / vystrihnúť vybrané dielce (aj pravé tlačidlo na riadku)"],
  ["Ctrl + V", "Vložiť pod vybraný riadok, pri vybranej zostave na jej koniec"],
  ["Escape", "Zrušiť hromadný výber a vystrihnutie"],
  ["Ctrl + Z", "Vrátiť poslednú zmenu (len v tejto session)"],
  ["?", "Tento prehľad"],
];

/** Prehľad klávesových skratiek editora (otvára kláves „?"). */
export function SkratkyDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
}): JSX.Element {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Klávesové skratky</DialogTitle>
          <DialogDescription className="sr-only">
            Prehľad klávesových skratiek v editore zákazky.
          </DialogDescription>
        </DialogHeader>
        <table className="w-full text-sm">
          <tbody>
            {SKRATKY.map(([klavesa, popis]) => (
              <tr key={klavesa} className="border-b last:border-b-0">
                <td className="py-1.5 pr-3">
                  <kbd className="rounded border bg-muted px-1.5 py-0.5 font-mono text-xs">
                    {klavesa}
                  </kbd>
                </td>
                <td className="py-1.5 text-muted-foreground">{popis}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
}
